// import { useEffect, useRef, useState } from "react";
// import "./ChatWidget.css";
// // import logo from "../assets/shopLogo.png";
// import logo from "../../assets/shopLogo.png";
// import { useNavigate } from "react-router-dom";

// // const API_URL = "https://shopeindia-chatbot-backend.onrender.com/chat";

// const API_URL =
//   process.env.REACT_APP_CHATBOT_API_URL ||
//   "https://shopeindia-chatbot-backend.onrender.com/chat";

// const quickActions = [
//   "Hijama suction gun under ₹300",
//   "Best derma pen",
//   "Suggest massage tools",
//   "Clinic gloves",
//   "Contact support",
// ];

// function ChatWidget() {
//   const navigate = useNavigate();
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     {
//       role: "bot",
//       text: "Hi 👋 Welcome to ShopeIndia!\nI can help you find Hijama, Derma, Massage, Therapy, and Beauty products.",
//       products: [],
//     },
//   ]);
//   const [input, setInput] = useState("");
//   const [isTyping, setIsTyping] = useState(false);

//   const messagesEndRef = useRef(null);
//   const inputRef = useRef(null);
//   const widgetRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (widgetRef.current && !widgetRef.current.contains(e.target)) {
//         setIsOpen(false);
//       }
//     };
//     if (isOpen) document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isOpen]);

//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages, isTyping]);

//   useEffect(() => {
//     if (isOpen) setTimeout(() => inputRef.current?.focus(), 200);
//   }, [isOpen]);

//   // function getProductUrl(url, productName) {
//   //   if (url && (url.startsWith("http://") || url.startsWith("https://"))) return url;
//   //   return `https://shopeindia.co.in/ShopPage?search=${encodeURIComponent(productName || "")}`;
//   // }

// //   function getProductUrl(url, productName, productId) {
// //   // 1. Agar backend proper URL deta hai
// //   if (url && (url.startsWith("http://") || url.startsWith("https://"))) {
// //     return url;
// //   }

// //   // 2. Agar product id hai → direct detail page
// //   if (productId) {
// //     return `https://shopeindia.co.in/DetailsSection3/${productId}`;
// //   }

// //   // 3. fallback → search page
// //   return `https://shopeindia.co.in/products?search=${encodeURIComponent(productName || "")}`;
// // }

// function getProductUrl(url, productName, productId) {
//   // ❌ URL ignore karo (kyunki slug aa raha hai)
  
//   // ✅ Direct ID use karo
//   if (productId) {
//     return `https://shopeindia.co.in/DetailsSection3/${productId}`;
//   }

//   // fallback
//   return `https://shopeindia.co.in/products?search=${encodeURIComponent(productName || "")}`;
// }

//   async function sendMessage(customMessage) {
//     const userMessage = customMessage || input.trim();
//     if (!userMessage || isTyping) return;

//   console.log("API_URL:", API_URL);  // ← YEH ADD KARO
//   console.log("Sending:", userMessage);  
//     setMessages((prev) => [...prev, { role: "user", text: userMessage, products: [] }]);
//     setInput("");
//     setIsTyping(true);

//     // 60 second timeout — Render free tier wakeup ke liye
//     const controller = new AbortController();
//     const timeoutId = setTimeout(() => controller.abort(), 60000);

//     try {
//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ message: userMessage }),
//         signal: controller.signal,
//       });

//       clearTimeout(timeoutId);

//       // Response text pehle lo — JSON parse error debug ke liye
//       const rawText = await response.text();
//       console.log("Backend raw response:", rawText);

//       let data;
//       try {
//         data = JSON.parse(rawText);
//       } catch {
//         throw new Error(`Invalid JSON from server: ${rawText.slice(0, 100)}`);
//       }

//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: ${data?.detail || rawText}`);
//       }

//       setMessages((prev) => [
//         ...prev,
//         {
//           role: "bot",
//           text: data.reply || "Sorry, could not generate a proper answer. Please try again.",
//           products: data.products || [],
//         },
//       ]);
//     } catch (error) {
//       clearTimeout(timeoutId);

//       // Exact error console mein print karo
//       console.error("ChatWidget fetch error:", error);

//       let errorText;

//       if (error.name === "AbortError") {
//         errorText =
//           "Server is taking too long to respond (60s timeout).\nRender server is probably waking up — please wait 1 minute and try again.";
//       } else if (error.message.includes("Failed to fetch") || error.message.includes("NetworkError")) {
//         errorText =
//           "Network error — could not reach the server.\nPossible reasons:\n• Server is offline\n• CORS issue (check browser console)\n• No internet connection";
//       } else {
//         errorText = `Error: ${error.message}`;
//       }

//       setMessages((prev) => [
//         ...prev,
//         {
//           role: "bot",
//           text: errorText,
//           products: [],
//         },
//       ]);
//     } finally {
//       setIsTyping(false);
//     }
//   }

//   function handleKeyDown(e) {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       sendMessage();
//     }
//   }

//   function renderText(text) {
//     return text.split("\n").map((line, i) => (
//       <p key={i} className="si-message-line">{line}</p>
//     ));
//   }

//   return (
//     <>
//       {!isOpen && (
//         <button
//           className="si-chat-toggle"
//           onClick={() => setIsOpen(true)}
//           aria-label="Open ShopeIndia chat"
//         >
//           {/* <img
//             className="si-chat-toggle-logo"
//             src="/images/shopLogo.png"
//             alt="ShopeIndia"
//           /> */}
//           <img  className="si-chat-toggle-logo" src={logo} alt="ShopeIndia Logo" />
//           <span className="si-chat-toggle-pulse" />
//         </button>
//       )}

//       {isOpen && (
//         <section className="si-chat-widget" ref={widgetRef}>

//           <header className="si-chat-header">
//             <div className="si-brand-block">
//               <div className="si-brand-avatar">
//                 {/* <img src="/images/shopLogo.png" alt="ShopeIndia Logo" /> */}
//                 <img src={logo} alt="ShopeIndia Logo" />
//               </div>
//               <div className="si-brand-info">
//                 <strong>ShopeIndia Assistant</strong>
//                 <span>
//                   <span className="si-online-dot" />
//                   Wellness &amp; Beauty Guide
//                 </span>
//               </div>
//             </div>

//             <button
//               className="si-chat-close"
//               onClick={() => setIsOpen(false)}
//               aria-label="Close chat"
//             >
//               ×
//             </button>
//           </header>

//           <main className="si-chat-messages">
//             {messages.map((msg, i) => (
//               <div
//                 key={i}
//                 className={`si-message-row ${msg.role === "user" ? "si-user-row" : "si-bot-row"}`}
//               >
//                 {msg.role === "bot" && (
//                   <div className="si-small-avatar">
//                     {/* <img src="/images/shopLogo.png" alt="Bot" /> */}
//                     <img src={logo} alt="ShopeIndia Logo" />
//                   </div>
//                 )}

//                 <div className="si-message-content">
//                   <div className={msg.role === "user" ? "si-user-message" : "si-bot-message"}>
//                     {renderText(msg.text)}
//                   </div>

//                   {msg.products?.length > 0 && (
//                     <div className="si-product-list">
//                       {msg.products.map((p) => (
//                         <article className="si-product-card" key={p.id}>
//                           <div className="si-product-top">
//                             <div>
//                               <h4>{p.name}</h4>
//                               <p>{p.category}</p>
//                             </div>
//                             {p.discount && (
//                               <span className="si-discount-badge">{p.discount}</span>
//                             )}
//                           </div>

//                           <div className="si-product-price">
//                             <strong>₹{p.price}</strong>
//                             {p.old_price && <span>₹{p.old_price}</span>}
//                             {p.rating && <small>⭐ {p.rating}</small>}
//                           </div>

//                           {/* <a
//                             href={getProductUrl(p.product_url, p.name, p.id)}
//                             target="_blank"
//                             rel="noreferrer"
//                             className="si-product-link"
//                           >
//                             View Product →
//                           </a> */}

//                           <button
//   onClick={() => navigate(`/DetailsSection3/${p.id}`)}
//   className="si-product-link border-0"
// >
//   View Product →
// </button> 
//                         </article>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))}

//             {messages.length === 1 && (
//               <div className="si-quick-actions">
//                 {quickActions.map((action) => (
//                   <button key={action} onClick={() => sendMessage(action)}>
//                     {action}
//                   </button>
//                 ))}
//               </div>
//             )}

//             {isTyping && (
//               <div className="si-message-row si-bot-row">
//                 <div className="si-small-avatar">
//                   {/* <img src="/images/shopLogo.png" alt="Bot" /> */}
//                   <img src={logo} alt="ShopeIndia Logo" />
//                 </div>
//                 <div className="si-typing-bubble">
//                   <span /><span /><span />
//                 </div>
//               </div>
//             )}

//             <div ref={messagesEndRef} />
//           </main>

//           <footer className="si-chat-footer">
//             <div className="si-chat-input-area">
//               <textarea
//                 ref={inputRef}
//                 value={input}
//                 onChange={(e) => setInput(e.target.value)}
//                 onKeyDown={handleKeyDown}
//                 placeholder="Ask about products..."
//                 rows={1}
//               />
//               <button
//                 className="si-send-btn"
//                 onClick={() => sendMessage()}
//                 disabled={isTyping || !input.trim()}
//               >
//                 Send
//               </button>
//             </div>
//             <div className="si-built-by">Built by Sanu Sharma</div>
//           </footer>
//         </section>
//       )}
//     </>
//   );
// }

// export default ChatWidget;


// // Todays try
// // import { useEffect, useRef, useState } from "react";
// // import "./ChatWidget.css";
// // // import logo from "../assets/shopLogo.png";
// // import logo from "../../assets/shopLogo.png";
// // import { useNavigate } from "react-router-dom";

// // // const API_URL = "https://shopeindia-chatbot-backend.onrender.com/chat";

// // const API_URL =
// //   process.env.REACT_APP_CHATBOT_API_URL ||
// //   "https://shopeindia-chatbot-backend.onrender.com/chat";

// // const quickActions = [
// //   "Hijama suction gun under ₹300",
// //   "Best derma pen",
// //   "Suggest massage tools",
// //   "Clinic gloves",
// //   "Contact support",
// // ];

// // function ChatWidget() {
// //   const navigate = useNavigate();
// //   const [isOpen, setIsOpen] = useState(false);
// //   const [messages, setMessages] = useState([
// //     {
// //       role: "bot",
// //       text: "Hi 👋 Welcome to ShopeIndia!\nI can help you find Hijama, Derma, Massage, Therapy, and Beauty products.",
// //       products: [],
// //     },
// //   ]);
// //   const [input, setInput] = useState("");
// //   const [isTyping, setIsTyping] = useState(false);

// //   const messagesEndRef = useRef(null);
// //   const inputRef = useRef(null);
// //   const widgetRef = useRef(null);

// //   useEffect(() => {
// //     const handleClickOutside = (e) => {
// //       if (widgetRef.current && !widgetRef.current.contains(e.target)) {
// //         setIsOpen(false);
// //       }
// //     };
// //     if (isOpen) document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, [isOpen]);

// //   useEffect(() => {
// //     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
// //   }, [messages, isTyping]);

// //   useEffect(() => {
// //     if (isOpen) setTimeout(() => inputRef.current?.focus(), 200);
// //   }, [isOpen]);

// //   async function sendMessage(customMessage) {
// //     const userMessage = customMessage || input.trim();
// //     if (!userMessage || isTyping) return;

// //     console.log("API_URL:", API_URL);
// //     console.log("Sending:", userMessage);
    
// //     setMessages((prev) => [...prev, { role: "user", text: userMessage, products: [] }]);
// //     setInput("");
// //     setIsTyping(true);

// //     // 60 second timeout — Render free tier wakeup ke liye
// //     const controller = new AbortController();
// //     const timeoutId = setTimeout(() => controller.abort(), 60000);

// //     try {
// //       const response = await fetch(API_URL, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ message: userMessage }),
// //         signal: controller.signal,
// //       });

// //       clearTimeout(timeoutId);

// //       // Response text pehle lo — JSON parse error debug ke liye
// //       const rawText = await response.text();
// //       console.log("Backend raw response:", rawText);

// //       let data;
// //       try {
// //         data = JSON.parse(rawText);
// //       } catch {
// //         throw new Error(`Invalid JSON from server: ${rawText.slice(0, 100)}`);
// //       }

// //       if (!response.ok) {
// //         throw new Error(`HTTP ${response.status}: ${data?.detail || rawText}`);
// //       }

// //       setMessages((prev) => [
// //         ...prev,
// //         {
// //           role: "bot",
// //           text: data.reply || "Sorry, could not generate a proper answer. Please try again.",
// //           products: data.products || [],
// //         },
// //       ]);
// //     } catch (error) {
// //       clearTimeout(timeoutId);

// //       // Exact error console mein print karo
// //       console.error("ChatWidget fetch error:", error);

// //       let errorText;

// //       if (error.name === "AbortError") {
// //         errorText =
// //           "Server is taking too long to respond (60s timeout).\nRender server is probably waking up — please wait 1 minute and try again.";
// //       } else if (error.message.includes("Failed to fetch") || error.message.includes("NetworkError")) {
// //         errorText =
// //           "Network error — could not reach the server.\nPossible reasons:\n• Server is offline\n• CORS issue (check browser console)\n• No internet connection";
// //       } else {
// //         errorText = `Error: ${error.message}`;
// //       }

// //       setMessages((prev) => [
// //         ...prev,
// //         {
// //           role: "bot",
// //           text: errorText,
// //           products: [],
// //         },
// //       ]);
// //     } finally {
// //       setIsTyping(false);
// //     }
// //   }

// //   function handleKeyDown(e) {
// //     if (e.key === "Enter" && !e.shiftKey) {
// //       e.preventDefault();
// //       sendMessage();
// //     }
// //   }

// //   function renderText(text) {
// //     return text.split("\n").map((line, i) => (
// //       <p key={i} className="si-message-line">{line}</p>
// //     ));
// //   }

// //   return (
// //     <>
// //       {!isOpen && (
// //         <button
// //           className="si-chat-toggle"
// //           onClick={() => setIsOpen(true)}
// //           aria-label="Open ShopeIndia chat"
// //         >
// //           {/* <img
// //             className="si-chat-toggle-logo"
// //             src="/images/shopLogo.png"
// //             alt="ShopeIndia"
// //           /> */}
// //           <img  className="si-chat-toggle-logo" src={logo} alt="ShopeIndia Logo" />
// //           <span className="si-chat-toggle-pulse" />
// //         </button>
// //       )}

// //       {isOpen && (
// //         <section className="si-chat-widget" ref={widgetRef}>

// //           <header className="si-chat-header">
// //             <div className="si-brand-block">
// //               <div className="si-brand-avatar">
// //                 {/* <img src="/images/shopLogo.png" alt="ShopeIndia Logo" /> */}
// //                 <img src={logo} alt="ShopeIndia Logo" />
// //               </div>
// //               <div className="si-brand-info">
// //                 <strong>ShopeIndia Assistant</strong>
// //                 <span>
// //                   <span className="si-online-dot" />
// //                   Wellness &amp; Beauty Guide
// //                 </span>
// //               </div>
// //             </div>

// //             <button
// //               className="si-chat-close"
// //               onClick={() => setIsOpen(false)}
// //               aria-label="Close chat"
// //             >
// //               ×
// //             </button>
// //           </header>

// //           <main className="si-chat-messages">
// //             {messages.map((msg, i) => (
// //               <div
// //                 key={i}
// //                 className={`si-message-row ${msg.role === "user" ? "si-user-row" : "si-bot-row"}`}
// //               >
// //                 {msg.role === "bot" && (
// //                   <div className="si-small-avatar">
// //                     {/* <img src="/images/shopLogo.png" alt="Bot" /> */}
// //                     <img src={logo} alt="ShopeIndia Logo" />
// //                   </div>
// //                 )}

// //                 <div className="si-message-content">
// //                   <div className={msg.role === "user" ? "si-user-message" : "si-bot-message"}>
// //                     {renderText(msg.text)}
// //                   </div>

// //                   {/* --- MODIFIED SECTION START --- */}
// //                   {msg.products?.length > 0 && (
// //                     <div className="si-product-list">
// //                       {msg.products.map((p) => {
// //                         // ID priority: prod_id > product_id > id
// //                         const idToUse = p.prod_id || p.product_id || p.id;
// //                         const productName = p.name || p.Product_name || "";

// //                         return (
// //                           <article className="si-product-card" key={p.id || p.prod_id}>
// //                             <div className="si-product-top">
// //                               <div>
// //                                 <h4>{p.name || p.Product_name}</h4>
// //                                 <p>{p.category}</p>
// //                               </div>
// //                               {p.discount && (
// //                                 <span className="si-discount-badge">{p.discount}</span>
// //                               )}
// //                             </div>

// //                             <div className="si-product-price">
// //                               <strong>₹{p.price || p.current_price}</strong>
// //                               {p.old_price && <span>₹{p.old_price}</span>}
// //                               {p.rating && <small>⭐ {p.rating}</small>}
// //                             </div>

// //                             <button
// //                               onClick={() => {
// //                                 // Check karein ki ID number hai ya nahi
// //                                 const isNumeric = !isNaN(idToUse) && idToUse !== "";
                                
// //                                 if (isNumeric) {
// //                                   // Agar number hai (jaise 378), sidha product page par jao
// //                                   navigate(`/DetailsSection3/${idToUse}`);
// //                                 } else {
// //                                   // Agar text/slug hai, search page par redirect karo
// //                                   navigate(`/products?search=${encodeURIComponent(productName)}`);
// //                                 }
// //                               }}
// //                               className="si-product-link"
// //                             >
// //                               View Product →
// //                             </button>
// //                           </article>
// //                         );
// //                       })}
// //                     </div>
// //                   )}
// //                   {/* --- MODIFIED SECTION END --- */}
// //                 </div>
// //               </div>
// //             ))}

// //             {messages.length === 1 && (
// //               <div className="si-quick-actions">
// //                 {quickActions.map((action) => (
// //                   <button key={action} onClick={() => sendMessage(action)}>
// //                     {action}
// //                   </button>
// //                 ))}
// //               </div>
// //             )}

// //             {isTyping && (
// //               <div className="si-message-row si-bot-row">
// //                 <div className="si-small-avatar">
// //                   {/* <img src="/images/shopLogo.png" alt="Bot" /> */}
// //                   <img src={logo} alt="ShopeIndia Logo" />
// //                 </div>
// //                 <div className="si-typing-bubble">
// //                   <span /><span /><span />
// //                 </div>
// //               </div>
// //             )}

// //             <div ref={messagesEndRef} />
// //           </main>

// //           <footer className="si-chat-footer">
// //             <div className="si-chat-input-area">
// //               <textarea
// //                 ref={inputRef}
// //                 value={input}
// //                 onChange={(e) => setInput(e.target.value)}
// //                 onKeyDown={handleKeyDown}
// //                 placeholder="Ask about products..."
// //                 rows={1}
// //               />
// //               <button
// //                 className="si-send-btn"
// //                 onClick={() => sendMessage()}
// //                 disabled={isTyping || !input.trim()}
// //               >
// //                 Send
// //               </button>
// //             </div>
// //             <div className="si-built-by">Built by Sanu Sharma</div>
// //           </footer>
// //         </section>
// //       )}
// //     </>
// //   );
// // }

// // export default ChatWidget;

// // import { useEffect, useRef, useState } from "react";
// // import "./ChatWidget.css";
// // // import logo from "../assets/shopLogo.png";
// // import logo from "../../assets/shopLogo.png";

// // // const API_URL = "https://shopeindia-chatbot-backend.onrender.com/chat";

// // const API_URL =
// //   process.env.REACT_APP_CHATBOT_API_URL ||
// //   "https://shopeindia-chatbot-backend.onrender.com/chat";

// // const quickActions = [
// //   "Hijama suction gun under ₹300",
// //   "Best derma pen",
// //   "Suggest massage tools",
// //   "Clinic gloves",
// //   "Contact support",
// // ];

// // function ChatWidget() {
// //   const [isOpen, setIsOpen] = useState(false);
// //   const [messages, setMessages] = useState([
// //     {
// //       role: "bot",
// //       text: "Hi 👋 Welcome to ShopeIndia!\nI can help you find Hijama, Derma, Massage, Therapy, and Beauty products.",
// //       products: [],
// //     },
// //   ]);
// //   const [input, setInput] = useState("");
// //   const [isTyping, setIsTyping] = useState(false);

// //   const messagesEndRef = useRef(null);
// //   const inputRef = useRef(null);
// //   const widgetRef = useRef(null);

// //   useEffect(() => {
// //     const handleClickOutside = (e) => {
// //       if (widgetRef.current && !widgetRef.current.contains(e.target)) {
// //         setIsOpen(false);
// //       }
// //     };
// //     if (isOpen) document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, [isOpen]);

// //   useEffect(() => {
// //     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
// //   }, [messages, isTyping]);

// //   useEffect(() => {
// //     if (isOpen) setTimeout(() => inputRef.current?.focus(), 200);
// //   }, [isOpen]);

// //   // ================= UPDATED LOGIC FOR PRODUCT REDIRECT =================
// //   function getProductUrl(url, productName, productId) {
// //     const domain = "https://shopeindia.co.in";

// //     // Case 1: Agar backend ne poora (https) link bheja hai toh wahi use karein
// //     if (url && (url.startsWith("http://") || url.startsWith("https://"))) {
// //       return url;
// //     }

// //     // Case 2: Agar relative link (/product/xyz) bheja hai
// //     if (url && url.startsWith("/")) {
// //       return `${domain}${url}`;
// //     }

// //     // Case 3: AGAR PRODUCT ID MILA HAI, TOH DETAILS PAGE PAR BHEJO (YEH LIKHA HAI)
// //     if (productId) {
// //       return `${domain}/DetailsSection3/${productId}`;
// //     }

// //     // Fallback: Agar kuch nahi toh search page par bhejo
// //     return `${domain}/ShopPage?search=${encodeURIComponent(productName || "")}`;
// //   }
// //   // ==========================================================================

// //   async function sendMessage(customMessage) {
// //     const userMessage = customMessage || input.trim();
// //     if (!userMessage || isTyping) return;

// //   console.log("API_URL:", API_URL);
// //   console.log("Sending:", userMessage);
// //     setMessages((prev) => [...prev, { role: "user", text: userMessage, products: [] }]);
// //     setInput("");
// //     setIsTyping(true);

// //     // 60 second timeout — Render free tier wakeup ke liye
// //     const controller = new AbortController();
// //     const timeoutId = setTimeout(() => controller.abort(), 60000);

// //     try {
// //       const response = await fetch(API_URL, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ message: userMessage }),
// //         signal: controller.signal,
// //       });

// //       clearTimeout(timeoutId);

// //       // Response text pehle lo — JSON parse error debug ke liye
// //       const rawText = await response.text();
// //       console.log("Backend raw response:", rawText);

// //       let data;
// //       try {
// //         data = JSON.parse(rawText);
// //       } catch {
// //         throw new Error(`Invalid JSON from server: ${rawText.slice(0, 100)}`);
// //       }

// //       if (!response.ok) {
// //         throw new Error(`HTTP ${response.status}: ${data?.detail || rawText}`);
// //       }

// //       setMessages((prev) => [
// //         ...prev,
// //         {
// //           role: "bot",
// //           text: data.reply || "Sorry, could not generate a proper answer. Please try again.",
// //           products: data.products || [],
// //         },
// //       ]);
// //     } catch (error) {
// //       clearTimeout(timeoutId);

// //       // Exact error console mein print karo
// //       console.error("ChatWidget fetch error:", error);

// //       let errorText;

// //       if (error.name === "AbortError") {
// //         errorText =
// //           "Server is taking too long to respond (60s timeout).\nRender server is probably waking up — please wait 1 minute and try again.";
// //       } else if (error.message.includes("Failed to fetch") || error.message.includes("NetworkError")) {
// //         errorText =
// //           "Network error — could not reach the server.\nPossible reasons:\n• Server is offline\n• CORS issue (check browser console)\n• No internet connection";
// //       } else {
// //         errorText = `Error: ${error.message}`;
// //       }

// //       setMessages((prev) => [
// //         ...prev,
// //         {
// //           role: "bot",
// //           text: errorText,
// //           products: [],
// //         },
// //       ]);
// //     } finally {
// //       setIsTyping(false);
// //     }
// //   }

// //   function handleKeyDown(e) {
// //     if (e.key === "Enter" && !e.shiftKey) {
// //       e.preventDefault();
// //       sendMessage();
// //     }
// //   }

// //   function renderText(text) {
// //     return text.split("\n").map((line, i) => (
// //       <p key={i} className="si-message-line">{line}</p>
// //     ));
// //   }

// //   return (
// //     <>
// //       {!isOpen && (
// //         <button
// //           className="si-chat-toggle"
// //           onClick={() => setIsOpen(true)}
// //           aria-label="Open ShopeIndia chat"
// //         >
// //           <img  className="si-chat-toggle-logo" src={logo} alt="ShopeIndia Logo" />
// //           <span className="si-chat-toggle-pulse" />
// //         </button>
// //       )}

// //       {isOpen && (
// //         <section className="si-chat-widget" ref={widgetRef}>

// //           <header className="si-chat-header">
// //             <div className="si-brand-block">
// //               <div className="si-brand-avatar">
// //                 <img src={logo} alt="ShopeIndia Logo" />
// //               </div>
// //               <div className="si-brand-info">
// //                 <strong>ShopeIndia Assistant</strong>
// //                 <span>
// //                   <span className="si-online-dot" />
// //                   Wellness &amp; Beauty Guide
// //                 </span>
// //               </div>
// //             </div>

// //             <button
// //               className="si-chat-close"
// //               onClick={() => setIsOpen(false)}
// //               aria-label="Close chat"
// //             >
// //               ×
// //             </button>
// //           </header>

// //           <main className="si-chat-messages">
// //             {messages.map((msg, i) => (
// //               <div
// //                 key={i}
// //                 className={`si-message-row ${msg.role === "user" ? "si-user-row" : "si-bot-row"}`}
// //               >
// //                 {msg.role === "bot" && (
// //                   <div className="si-small-avatar">
// //                     <img src={logo} alt="ShopeIndia Logo" />
// //                   </div>
// //                 )}

// //                 <div className="si-message-content">
// //                   <div className={msg.role === "user" ? "si-user-message" : "si-bot-message"}>
// //                     {renderText(msg.text)}
// //                   </div>

// //                   {msg.products?.length > 0 && (
// //                     <div className="si-product-list">
// //                       {msg.products.map((p) => (
// //                         <article className="si-product-card" key={p.id}>
// //                           <div className="si-product-top">
// //                             <div>
// //                               <h4>{p.name}</h4>
// //                               <p>{p.category}</p>
// //                             </div>
// //                             {p.discount && (
// //                               <span className="si-discount-badge">{p.discount}</span>
// //                             )}
// //                           </div>

// //                           <div className="si-product-price">
// //                             <strong>₹{p.price}</strong>
// //                             {p.old_price && <span>₹{p.old_price}</span>}
// //                             {p.rating && <small>⭐ {p.rating}</small>}
// //                           </div>

// //                           {/* Yahan humne p.id add kiya hai function mein */}
// //                           <a
// //                             href={getProductUrl(p.product_url, p.name, p.id)}
// //                             target="_blank"
// //                             rel="noreferrer"
// //                             className="si-product-link"
// //                           >
// //                             View Product →
// //                           </a>
// //                         </article>
// //                       ))}
// //                     </div>
// //                   )}
// //                 </div>
// //               </div>
// //             ))}

// //             {messages.length === 1 && (
// //               <div className="si-quick-actions">
// //                 {quickActions.map((action) => (
// //                   <button key={action} onClick={() => sendMessage(action)}>
// //                     {action}
// //                   </button>
// //                 ))}
// //               </div>
// //             )}

// //             {isTyping && (
// //               <div className="si-message-row si-bot-row">
// //                 <div className="si-small-avatar">
// //                   <img src={logo} alt="ShopeIndia Logo" />
// //                 </div>
// //                 <div className="si-typing-bubble">
// //                   <span /><span /><span />
// //                 </div>
// //               </div>
// //             )}

// //             <div ref={messagesEndRef} />
// //           </main>

// //           <footer className="si-chat-footer">
// //             <div className="si-chat-input-area">
// //               <textarea
// //                 ref={inputRef}
// //                 value={input}
// //                 onChange={(e) => setInput(e.target.value)}
// //                 onKeyDown={handleKeyDown}
// //                 placeholder="Ask about products..."
// //                 rows={1}
// //               />
// //               <button
// //                 className="si-send-btn"
// //                 onClick={() => sendMessage()}
// //                 disabled={isTyping || !input.trim()}
// //               >
// //                 Send
// //               </button>
// //             </div>
// //             <div className="si-built-by">Built by Sanu Sharma</div>
// //           </footer>
// //         </section>
// //       )}
// //     </>
// //   );
// // }

// // export default ChatWidget;

// // 3rd try

// // import { useEffect, useRef, useState } from "react";
// // import "./ChatWidget.css";
// // import logo from "../../assets/shopLogo.png";

// // const API_URL =
// //   process.env.REACT_APP_CHATBOT_API_URL ||
// //   "https://shopeindia-chatbot-backend.onrender.com/chat";

// // const quickActions = [
// //   "Hijama suction gun under ₹300",
// //   "Best derma pen",
// //   "Suggest massage tools",
// //   "Clinic gloves",
// //   "Contact support",
// // ];

// // function ChatWidget() {
// //   const [isOpen, setIsOpen] = useState(false);
// //   const [messages, setMessages] = useState([
// //     {
// //       role: "bot",
// //       text: "Hi 👋 Welcome to ShopeIndia!\nI can help you find Hijama, Derma, Massage, Therapy, and Beauty products.",
// //       products: [],
// //     },
// //   ]);
// //   const [input, setInput] = useState("");
// //   const [isTyping, setIsTyping] = useState(false);
  
// //   // NAYA STATE: Saare products load karne ke liye
// //   const [allProducts, setAllProducts] = useState([]);

// //   const messagesEndRef = useRef(null);
// //   const inputRef = useRef(null);
// //   const widgetRef = useRef(null);

// //   // 1. Component load hote hi saare products fetch kar lo
// //   useEffect(() => {
// //     const fetchProductList = async () => {
// //       try {
// //         const response = await fetch("https://ecom.cyberathon.com/index.php/Api/list_get_product");
// //         const data = await response.json();
// //         if (data && data.status && data.products) {
// //           setAllProducts(data.products);
// //         }
// //       } catch (error) {
// //         console.error("Failed to load product list:", error);
// //       }
// //     };

// //     fetchProductList();
// //   }, []);

// //   // 2. Helper Function: Name se ID dhoondhne ke liye
// //   function findProductIdByName(productName) {
// //     // Exact match try karo
// //     const product = allProducts.find((p) => p.Product_name === productName);
    
// //     // Agar exact match nahi mila, toh Partial match try karo (Case insensitive)
// //     if (!product) {
// //       const partialMatch = allProducts.find((p) => 
// //         productName.toLowerCase().includes(p.Product_name.toLowerCase()) || 
// //         p.Product_name.toLowerCase().includes(productName.toLowerCase())
// //       );
// //       return partialMatch ? partialMatch.prod_id : null;
// //     }

// //     return product ? product.prod_id : null;
// //   }

// //   useEffect(() => {
// //     const handleClickOutside = (e) => {
// //       if (widgetRef.current && !widgetRef.current.contains(e.target)) {
// //         setIsOpen(false);
// //       }
// //     };
// //     if (isOpen) document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, [isOpen]);

// //   useEffect(() => {
// //     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
// //   }, [messages, isTyping]);

// //   useEffect(() => {
// //     if (isOpen) setTimeout(() => inputRef.current?.focus(), 200);
// //   }, [isOpen]);

// //   function getProductUrl(url, productName, productId) {
// //     const domain = "https://shopeindia.co.in";

// //     // Case 1: Backend ne poora (https) link bheja hai toh wahi use karein
// //     if (url && (url.startsWith("http://") || url.startsWith("https://"))) {
// //       return url;
// //     }

// //     // Case 2: Relative link (/product/xyz) bheja hai
// //     if (url && url.startsWith("/")) {
// //       return `${domain}${url}`;
// //     }

// //     // Case 3: AGAR PRODUCT ID MILA HAI, TOH DETAILS PAGE PAR BHEJO
// //     if (productId) {
// //       return `${domain}/DetailsSection3/${productId}`;
// //     }

// //     // Fallback: Agar kuch nahi toh search page par bhejo
// //     return `${domain}/ShopPage?search=${encodeURIComponent(productName || "")}`;
// //   }

// //   async function sendMessage(customMessage) {
// //     const userMessage = customMessage || input.trim();
// //     if (!userMessage || isTyping) return;

// //     console.log("API_URL:", API_URL);
// //     setMessages((prev) => [...prev, { role: "user", text: userMessage, products: [] }]);
// //     setInput("");
// //     setIsTyping(true);

// //     const controller = new AbortController();
// //     const timeoutId = setTimeout(() => controller.abort(), 60000);

// //     try {
// //       const response = await fetch(API_URL, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ message: userMessage }),
// //         signal: controller.signal,
// //       });

// //       clearTimeout(timeoutId);
// //       const rawText = await response.text();
// //       console.log("Backend raw response:", rawText);

// //       let data;
// //       try {
// //         data = JSON.parse(rawText);
// //       } catch {
// //         throw new Error(`Invalid JSON from server: ${rawText.slice(0, 100)}`);
// //       }

// //       if (!response.ok) {
// //         throw new Error(`HTTP ${response.status}: ${data?.detail || rawText}`);
// //       }

// //       // --- LOGIC UPDATED HAI YAHAAN ---
// //       const botProducts = data.products || [];
      
// //       // Hum products ko map karke ID dhundhenge
// //       const enrichedProducts = botProducts.map((p) => {
// //         // Agar pehle se ID hai toh use karein
// //         if (p.id) return p;

// //         // Agar ID nahi hai, toh humari Local List mein dhundo
// //         console.log(`Searching locally for: ${p.name}`);
// //         const realId = findProductIdByName(p.name);
// //         console.log(`Found ID: ${realId}`);
        
// //         // ID return karein (ya agar nahi mila toh null)
// //         return { ...p, id: realId };
// //       });

// //       setMessages((prev) => [
// //         ...prev,
// //         {
// //           role: "bot",
// //           text: data.reply || "Sorry, could not generate a proper answer. Please try again.",
// //           products: enrichedProducts,
// //         },
// //       ]);
      
// //     } catch (error) {
// //       clearTimeout(timeoutId);
// //       console.error("ChatWidget fetch error:", error);
      
// //       let errorText;
// //       if (error.name === "AbortError") {
// //         errorText = "Server is taking too long to respond (60s timeout).";
// //       } else if (error.message.includes("Failed to fetch")) {
// //         errorText = "Network error — could not reach the server.";
// //       } else {
// //         errorText = `Error: ${error.message}`;
// //       }

// //       setMessages((prev) => [
// //         ...prev,
// //         {
// //           role: "bot",
// //           text: errorText,
// //           products: [],
// //         },
// //       ]);
// //     } finally {
// //       setIsTyping(false);
// //     }
// //   }

// //   function handleKeyDown(e) {
// //     if (e.key === "Enter" && !e.shiftKey) {
// //       e.preventDefault();
// //       sendMessage();
// //     }
// //   }

// //   function renderText(text) {
// //     return text.split("\n").map((line, i) => (
// //       <p key={i} className="si-message-line">{line}</p>
// //     ));
// //   }

// //   return (
// //     <>
// //       {!isOpen && (
// //         <button
// //           className="si-chat-toggle"
// //           onClick={() => setIsOpen(true)}
// //           aria-label="Open ShopeIndia chat"
// //         >
// //           <img  className="si-chat-toggle-logo" src={logo} alt="ShopeIndia Logo" />
// //           <span className="si-chat-toggle-pulse" />
// //         </button>
// //       )}

// //       {isOpen && (
// //         <section className="si-chat-widget" ref={widgetRef}>

// //           <header className="si-chat-header">
// //             <div className="si-brand-block">
// //               <div className="si-brand-avatar">
// //                 <img src={logo} alt="ShopeIndia Logo" />
// //               </div>
// //               <div className="si-brand-info">
// //                 <strong>ShopeIndia Assistant</strong>
// //                 <span>
// //                   <span className="si-online-dot" />
// //                   Wellness &amp; Beauty Guide
// //                 </span>
// //               </div>
// //             </div>

// //             <button
// //               className="si-chat-close"
// //               onClick={() => setIsOpen(false)}
// //               aria-label="Close chat"
// //             >
// //               ×
// //             </button>
// //           </header>

// //           <main className="si-chat-messages">
// //             {messages.map((msg, i) => (
// //               <div
// //                 key={i}
// //                 className={`si-message-row ${msg.role === "user" ? "si-user-row" : "si-bot-row"}`}
// //               >
// //                 {msg.role === "bot" && (
// //                   <div className="si-small-avatar">
// //                     <img src={logo} alt="ShopeIndia Logo" />
// //                   </div>
// //                 )}

// //                 <div className="si-message-content">
// //                   <div className={msg.role === "user" ? "si-user-message" : "si-bot-message"}>
// //                     {renderText(msg.text)}
// //                   </div>

// //                   {msg.products?.length > 0 && (
// //                     <div className="si-product-list">
// //                       {msg.products.map((p) => (
// //                         <article className="si-product-card" key={p.id || p.name}>
// //                           <div className="si-product-top">
// //                             <div>
// //                               <h4>{p.name}</h4>
// //                               <p>{p.category}</p>
// //                             </div>
// //                             {p.discount && (
// //                               <span className="si-discount-badge">{p.discount}</span>
// //                             )}
// //                           </div>

// //                           <div className="si-product-price">
// //                             <strong>₹{p.price}</strong>
// //                             {p.old_price && <span>₹{p.old_price}</span>}
// //                             {p.rating && <small>⭐ {p.rating}</small>}
// //                           </div>

// //                           {/* Yahan hum p.id pass kar rahe hain jo ab upar logic se match hua hai */}
// //                           <a
// //                             href={getProductUrl(p.product_url, p.name, p.id)}
// //                             target="_blank"
// //                             rel="noreferrer"
// //                             className="si-product-link"
// //                           >
// //                             View Product →
// //                           </a>
// //                         </article>
// //                       ))}
// //                     </div>
// //                   )}
// //                 </div>
// //               </div>
// //             ))}

// //             {messages.length === 1 && (
// //               <div className="si-quick-actions">
// //                 {quickActions.map((action) => (
// //                   <button key={action} onClick={() => sendMessage(action)}>
// //                     {action}
// //                   </button>
// //                 ))}
// //               </div>
// //             )}

// //             {isTyping && (
// //               <div className="si-message-row si-bot-row">
// //                 <div className="si-small-avatar">
// //                   <img src={logo} alt="ShopeIndia Logo" />
// //                 </div>
// //                 <div className="si-typing-bubble">
// //                   <span /><span /><span />
// //                 </div>
// //               </div>
// //             )}

// //             <div ref={messagesEndRef} />
// //           </main>

// //           <footer className="si-chat-footer">
// //             <div className="si-chat-input-area">
// //               <textarea
// //                 ref={inputRef}
// //                 value={input}
// //                 onChange={(e) => setInput(e.target.value)}
// //                 onKeyDown={handleKeyDown}
// //                 placeholder="Ask about products..."
// //                 rows={1}
// //               />
// //               <button
// //                 className="si-send-btn"
// //                 onClick={() => sendMessage()}
// //                 disabled={isTyping || !input.trim()}
// //               >
// //                 Send
// //               </button>
// //             </div>
// //             <div className="si-built-by">Built by Sanu Sharma</div>
// //           </footer>
// //         </section>
// //       )}
// //     </>
// //   );
// // }

// // export default ChatWidget;

// Todays try
import { useEffect, useRef, useState } from "react";
import "./ChatWidget.css";
// import logo from "../assets/shopLogo.png";
import logo from "../../assets/shopLogo.png";
import { useNavigate } from "react-router-dom";

// const API_URL = "https://shopeindia-chatbot-backend.onrender.com/chat";

const API_URL =
  process.env.REACT_APP_CHATBOT_API_URL ||
  "https://shopeindia-chatbot-backend.onrender.com/chat";

const quickActions = [
  "Hijama suction gun under ₹300",
  "Best derma pen",
  "Suggest massage tools",
  "Clinic gloves",
  "Contact support",
];

function ChatWidget() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: "bot",
      text: "Hi 👋 Welcome to ShopeIndia!\nI can help you find Hijama, Derma, Massage, Therapy, and Beauty products.",
      products: [],
    },
  ]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const widgetRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (widgetRef.current && !widgetRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isTyping]);

  useEffect(() => {
    if (isOpen) setTimeout(() => inputRef.current?.focus(), 200);
  }, [isOpen]);

  async function sendMessage(customMessage) {
    const userMessage = customMessage || input.trim();
    if (!userMessage || isTyping) return;

    console.log("API_URL:", API_URL);
    console.log("Sending:", userMessage);
    
    setMessages((prev) => [...prev, { role: "user", text: userMessage, products: [] }]);
    setInput("");
    setIsTyping(true);

    // 60 second timeout — Render free tier wakeup ke liye
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 60000);

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userMessage }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      // Response text pehle lo — JSON parse error debug ke liye
      const rawText = await response.text();
      console.log("Backend raw response:", rawText);

      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(`Invalid JSON from server: ${rawText.slice(0, 100)}`);
      }

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${data?.detail || rawText}`);
      }

      setMessages((prev) => [
        ...prev,
        {
          role: "bot",
          text: data.reply || "Sorry, could not generate a proper answer. Please try again.",
          products: data.products || [],
        },
      ]);
    } catch (error) {
      clearTimeout(timeoutId);

      // Exact error console mein print karo
      console.error("ChatWidget fetch error:", error);

      let errorText;

      if (error.name === "AbortError") {
        errorText =
          "Server is taking too long to respond (60s timeout).\nRender server is probably waking up — please wait 1 minute and try again.";
      } else if (error.message.includes("Failed to fetch") || error.message.includes("NetworkError")) {
        errorText =
          "Network error — could not reach the server.\nPossible reasons:\n• Server is offline\n• CORS issue (check browser console)\n• No internet connection";
      } else {
        errorText = `Error: ${error.message}`;
      }

      setMessages((prev) => [
        ...prev,
        {
          role: "bot",
          text: errorText,
          products: [],
        },
      ]);
    } finally {
      setIsTyping(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  }

  function renderText(text) {
    return text.split("\n").map((line, i) => (
      <p key={i} className="si-message-line">{line}</p>
    ));
  }

  return (
    <>
      {!isOpen && (
        <button
          className="si-chat-toggle"
          onClick={() => setIsOpen(true)}
          aria-label="Open ShopeIndia chat"
        >
          {/* <img
            className="si-chat-toggle-logo"
            src="/images/shopLogo.png"
            alt="ShopeIndia"
          /> */}
          <img  className="si-chat-toggle-logo" src={logo} alt="ShopeIndia Logo" />
          <span className="si-chat-toggle-pulse" />
        </button>
      )}

      {isOpen && (
        <section className="si-chat-widget" ref={widgetRef}>

          <header className="si-chat-header">
            <div className="si-brand-block">
              <div className="si-brand-avatar">
                {/* <img src="/images/shopLogo.png" alt="ShopeIndia Logo" /> */}
                <img src={logo} alt="ShopeIndia Logo" />
              </div>
              <div className="si-brand-info">
                <strong>ShopeIndia Assistant</strong>
                <span>
                  <span className="si-online-dot" />
                  Wellness &amp; Beauty Guide
                </span>
              </div>
            </div>

            <button
              className="si-chat-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close chat"
            >
              ×
            </button>
          </header>

          <main className="si-chat-messages">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`si-message-row ${msg.role === "user" ? "si-user-row" : "si-bot-row"}`}
              >
                {msg.role === "bot" && (
                  <div className="si-small-avatar">
                    {/* <img src="/images/shopLogo.png" alt="Bot" /> */}
                    <img src={logo} alt="ShopeIndia Logo" />
                  </div>
                )}

                <div className="si-message-content">
                  <div className={msg.role === "user" ? "si-user-message" : "si-bot-message"}>
                    {renderText(msg.text)}
                  </div>

                  {/* --- MODIFIED SECTION START --- */}
                  {msg.products?.length > 0 && (
                    <div className="si-product-list">
                      {msg.products.map((p) => {
                        // ID priority: prod_id > product_id > id
                        const idToUse = p.prod_id || p.product_id || p.id;
                        const productName = p.name || p.Product_name || "";

                        return (
                          <article className="si-product-card" key={p.id || p.prod_id}>
                            <div className="si-product-top">
                              <div>
                                <h4>{p.name || p.Product_name}</h4>
                                <p>{p.category}</p>
                              </div>
                              {p.discount && (
                                <span className="si-discount-badge">{p.discount}</span>
                              )}
                            </div>

                            <div className="si-product-price">
                              <strong>₹{p.price || p.current_price}</strong>
                              {p.old_price && <span>₹{p.old_price}</span>}
                              {p.rating && <small>⭐ {p.rating}</small>}
                            </div>

                            <button
                              onClick={() => {
  const idToUse = p.prod_id || p.product_id || p.id;

  if (!idToUse) return;

  navigate(`/DetailsSection3/${idToUse}`);
}}
                              className="si-product-link border-0"
                            >
                              View Product →
                            </button>
                          </article>
                        );
                      })}
                    </div>
                  )}
                  {/* --- MODIFIED SECTION END --- */}
                </div>
              </div>
            ))}

            {messages.length === 1 && (
              <div className="si-quick-actions">
                {quickActions.map((action) => (
                  <button key={action} onClick={() => sendMessage(action)}>
                    {action}
                  </button>
                ))}
              </div>
            )}

            {isTyping && (
              <div className="si-message-row si-bot-row">
                <div className="si-small-avatar">
                  {/* <img src="/images/shopLogo.png" alt="Bot" /> */}
                  <img src={logo} alt="ShopeIndia Logo" />
                </div>
                <div className="si-typing-bubble">
                  <span /><span /><span />
                </div>
              </div>
            )}

            <div ref={messagesEndRef} />
          </main>

          <footer className="si-chat-footer">
            <div className="si-chat-input-area">
              <textarea
                ref={inputRef}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Ask about products..."
                rows={1}
              />
              <button
                className="si-send-btn"
                onClick={() => sendMessage()}
                disabled={isTyping || !input.trim()}
              >
                Send
              </button>
            </div>
            <div className="si-built-by">Built by Sanu Sharma</div>
          </footer>
        </section>
      )}
    </>
  );
}

export default ChatWidget;